import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {autobind} from 'core-decorators';
import styles from './styles.css';

@autobind
export default class Select extends Component {
    static propTypes = {
        options: PropTypes.arrayOf(PropTypes.shape({
            value: PropTypes.any.isRequired,
            label: PropTypes.string.isRequired,
        })).isRequired,
        value: PropTypes.any.isRequired,
        placeholder: PropTypes.string,
        clearable: PropTypes.bool,
        clearLabel: PropTypes.string,
        emptyValue: PropTypes.any,
        theme: PropTypes.oneOf(['outline', 'gray']),
        disabled: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func,
        onClear: PropTypes.func,
        onChangeAfter: PropTypes.bool,
    };

    static defaultProps = {
        theme: 'outline',
        emptyValue: '',
        clearLabel: 'Limpiar selección',
        onChangeAfterClear: true,
    };

    state = {
        focus: false,
    };

    getSelectedIndex() {
        return this.props.options.findIndex(option => option.value === this.props.value);
    }

    getOptionKey(option) {
        return option.label + option.value;
    }

    handleFocus() {
        this.setState({focus: true});
    }

    handleBlur() {
        this.setState({focus: false});
        if (this.props.onBlur) this.props.onBlur();
    }

    handleChange(event) {
        const index = event.target.value;

        if (!index) {
            if (this.props.clearable && this.props.onClear) {
                this.props.onClear();
            }
            this.props.onChange(this.props.emptyValue);
        } else {
            const option = this.props.options[Number(index)];
            this.props.onChange(option.value, option);
        }

        if (this.props.onBlur) this.props.onBlur();
    }

    renderValue() {
        const selectedIndex = this.getSelectedIndex();
        const selectedOption = selectedIndex >= 0 && this.props.options[selectedIndex];

        if (!selectedOption && this.props.placeholder) {
            return (
                <div className={styles.placeholder}>
                    <span>{this.props.placeholder}</span>
                </div>
            );
        }

        return (
            <div className={styles.value}>
                <span>{selectedOption && selectedOption.label}</span>
            </div>
        );
    }

    render() {
        const selectedIndex = this.getSelectedIndex();
        return (
            <div className={classNames(
                styles.root,
                styles[this.props.theme],
                this.props.disabled && styles.disabled,
                this.state.focus && styles.focused,
            )}>
                {this.renderValue()}
                <i className='material-icons'>keyboard_arrow_down</i>
                <select
                    value={selectedIndex}
                    disabled={this.props.disabled}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    onChange={this.handleChange}>
                    {selectedIndex === -1 && (
                        <option value=''>
                            {this.props.placeholder || 'Seleccioná una opción'}
                        </option>
                    )}
                    {selectedIndex >= 0 && this.props.clearable && (
                        <option value=''>
                            {this.props.clearLabel}
                        </option>
                    )}
                    {this.props.options.map((option, index) => (
                        <option key={this.getOptionKey(option)} value={index}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/forms/select/index.js